import { resetPasswordWithTokenDialogReducerKey } from './ResetPasswordWithTokenDialogConstants';

export const resetPasswordWithTokenDialog = (state) => state.get(resetPasswordWithTokenDialogReducerKey);

export const isLoading = (state) => resetPasswordWithTokenDialog(state).get('isLoading');

export const newPassword = (state) => resetPasswordWithTokenDialog(state).get('newPassword');

export const confirmationPassword = (state) => resetPasswordWithTokenDialog(state).get('confirmationPassword');
